"use client"

import { SectionType } from "Components/Sections/sections"
import { ReactNode, useEffect, useState } from "react"
import { transitionTime } from "theme/shared"
import { GlobalContext } from "./GlobalContext"

interface GlobalContextProviderProps {
  sections: SectionType[]
  children: ReactNode
}

const GlobalContextProvider = ({
  children,
  sections = [], // Default to empty array if not provided
}: GlobalContextProviderProps) => {
  const [activeSectionIndex, setActiveSectionIndex] = useState(0)
  const [openMenu, setOpenMenu] = useState(false)
  const [active, setActive] = useState<number>(0)
  const [prev, setPrev] = useState<number | null>(null)
  const [next, setNext] = useState<number | null>(null)

  useEffect(() => {
    setNext(activeSectionIndex)
    // Set active immediately - the 1ms delay was causing race conditions
    // where sections after Services wouldn't show content
    setActive(activeSectionIndex)
  }, [activeSectionIndex])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPrev(null)
      setNext(null)
    }, transitionTime)
    return () => {
      clearTimeout(timeout)
    }
  }, [prev])

  return (
    <GlobalContext.Provider
      value={{
        activeSectionIndex,
        setActiveSectionIndex,
        activeSection:
          sections[activeSectionIndex] || sections[0] || ({} as any),
        openMenu,
        setOpenMenu,
        active,
        setActive,
        prev,
        setPrev,
        next,
        setNext,
        sections,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalContextProvider
